import { createResourceError } from '@atlassian/jira-router-resources-utils/src/utils/create-resource-error/index.tsx';
import { setMark } from '@atlassian/jira-common-performance/src/marks.tsx';
// eslint-disable-next-line jira/import-whitelist
import {
	prefetchApiReadyMark,
	prefetchApiStartMark,
} from '@atlassian/jira-providers-spa-apdex-analytics/src/marks.tsx';
import type { ResourceStoreContext, RouterDataContext } from '@atlassian/react-resource-router';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export const fetchWorkflowBuilderProvisioning = async (
	{ match: _match }: RouterDataContext,
	{ tenantContext }: ResourceStoreContext,
) => {
	const { isAnonymous, cloudId } = tenantContext;

	if (isAnonymous) {
		const message = "Workflows can't be edited in anonymous mode.";
		throw new Error(message);
	}

	try {
		setMark(prefetchApiStartMark);
		await performPostRequest(
			'/gateway/api/assist/v1/agent/provisioning/ootb/jira_workflow_builder_agent',
			{
				headers: {
					'X-Product': 'jira',
					'X-Experience-Id': 'ai-mate',
					'Atl-Cloudid': cloudId,
				},
			},
		);
		setMark(prefetchApiReadyMark);

		// If the request is successful, we return true as this means that the workflow builder was already provisioned or has just succesfully been provisioned
		return true;

		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		throw createResourceError(
			{
				component: 'spa.view.routes.admin-pages.workflows.workflow-builder-provisioning.getData',
				message: 'An error was thrown while prefetching workflow builder provisioning',
				name: 'ResourceError',
			},
			error,
		);
	}
};
